<div class="auth-callback-container">
    <div class="oauth-provider-section oauth-provider-section-card-style">
        <!-- Shared header - always visible -->
        <section class="login-card">
            <div class="section-header-title login-card-header">
                <div class="logo-container">
                    <img class="addboard-logo"
                         [ngSrc]="'../../../assets/img/addboard-logo.svg'"
                         alt="ADDboard Logo"
                         width="96"
                         height="96"
                         priority
                    >
                </div>
                <div class="claim-container">
                    <h3 class="claim-text">
                        {{'UC_SLOGAN_1' | translate}} {{'UC_SLOGAN_2' | translate}}
                    </h3>
                </div>
            </div>
        </section>

        <!-- Content changes based on state -->
        <section class="login-section">
            <!-- Processing state -->
            @if (!hasError) {
                <div class="loading-spinner">
                    <mat-progress-spinner
                            class="login-margin"
                            mode="indeterminate"
                    ></mat-progress-spinner>
                    @if (isCheckingConnection) {
                        <p class="loading-message">{{ 'CHECKING_CONNECTION' | translate }}</p>
                    } @else {
                        <p class="loading-message">{{ loadingMessage | translate }}</p>
                    }
                </div>
            }

            <!-- Error state -->
            @if (hasError && errorDetails) {
                <div class="error-content">
                    <!-- Error title -->
                    <h2 class="error-title">{{ errorDetails.title | translate }}</h2>

                    <!-- Error message -->
                    <p class="error-message">{{ errorDetails.message | translate }}</p>

                    <!-- Network status indicator (only for network errors) -->
                    @if (errorType === 'NETWORK' && !isOnline) {
                        <div class="network-status-badge">
                            <span>{{ 'NO_NETWORK_CONNECTION' | translate }}</span>
                        </div>
                    }

                    <!-- Single action button - Back to Login -->
                    <div class="error-actions">
                        <button
                                mat-raised-button
                                (click)="navigateToLogin()"
                                class="action-button primary"
                        >
                            <span>{{ 'BACK_TO_LOGIN' | translate }}</span>
                        </button>
                    </div>
                </div>
            }
        </section>
    </div>
</div>
